export const CheckoutEventError =
  typeof window === 'undefined' ? null : new window.CustomEvent('CheckoutError')

export const CheckoutEventChange =
  typeof window === 'undefined'
    ? null
    : new window.CustomEvent('CheckoutChange')
